import { actionCreator } from 'utils';
import * as statisticsTypes from '../types/statisticType';


// E X P O R T S
export function loadStatisticsExports(data) {
    return {
        type: statisticsTypes.LOAD_STATISTICS_EXPORTS,
        data,
    };
}

export function setStatisticsExportsPagination(key, pagination) {
    return {
        type: statisticsTypes.SET_STATISTICS_EXPORTS_PAGINATION,
        key,
        pagination,
    };
}

export function exportStatisticsGroups(data) {
    return {
        type: statisticsTypes.EXPORT_STATISTICS_GROUPS,
        data,
    };
}

export function exportStatisticsGroupsRes(data) {
    return {
        type: actionCreator(statisticsTypes.EXPORT_STATISTICS_GROUPS, 'res'),
        data,
    };
}

export function exportStatisticsGroupsErr() {
    return {
        type: actionCreator(statisticsTypes.EXPORT_STATISTICS_GROUPS, 'err'),
    };
}
// E X P O R T S

// A C C O U N T A N C Y   G R O U P S
export function loadStatisticsGroups() {
    return {
        type: statisticsTypes.LOAD_STATISTICS_GROUPS,
    };
}

export function loadStatisticsGroupsRes(data) {
    return {
        type: actionCreator(statisticsTypes.LOAD_STATISTICS_GROUPS, 'res'),
        data,
    };
}

export function loadStatisticsGroupsErr() {
    return {
        type: actionCreator(statisticsTypes.LOAD_STATISTICS_GROUPS, 'err'),
    };
}
// A C C O U N T A N C Y   G R O U P S

// I N V O I C E
export function loadStatisticsInvoice() {
    return {
        type: statisticsTypes.LOAD_STATISTICS_INVOICE,
    };
}

export function loadStatisticsInvoiceRes(data) {
    return {
        type: actionCreator(statisticsTypes.LOAD_STATISTICS_INVOICE, 'res'),
        data,
    };
}

export function loadStatisticsInvoiceErr() {
    return {
        type: actionCreator(statisticsTypes.LOAD_STATISTICS_INVOICE, 'err'),
    };
}

export function setStatisticsInvoicePagination(key, pagination) {
    return {
        type: statisticsTypes.SET_STATISTICS_INVOICE_PAGINATION,
        key,
        pagination,
    };
}

export function loadStatisticsInvoiceOrders() {
    return {
        type: statisticsTypes.LOAD_STATISTICS_INVOICE_ORDERS,
    };
}

export function loadStatisticsInvoiceOrdersErr() {
    return {
        type: actionCreator(statisticsTypes.LOAD_STATISTICS_INVOICE_ORDERS, 'err'),
    };
}

export function loadStatisticsInvoiceOrdersRes(data) {
    return {
        type: actionCreator(statisticsTypes.LOAD_STATISTICS_INVOICE_ORDERS, 'res'),
        data,
    };
}

export function setStatisticsInvoiceSort(key, type) {
    return {
        type: statisticsTypes.SET_STATISTICS_INVOICE_SORT,
        sort: {
            key,
            type,
        },
    };
}

export function setStatisticsInvoiceFilters(key, value) {
    return {
        type: statisticsTypes.SET_STATISTICS_INVOICE_FILTERS,
        key,
        value,
    };
}

export function resetStatisticsInvoiceFilters() {
    return {
        type: statisticsTypes.RESET_STATISTICS_INVOICE_FILTERS,
    };
}
// I N V O I C E

// E X P O R T   I N V O I C E S
export function exportInvoices(invoiceType, invoiceAction, limit) {
    return {
        type: statisticsTypes.EXPORT_INVOICES,
        invoiceType,
        invoiceAction,
        limit,
    };
}

export function exportInvoicesRes() {
    return {
        type: actionCreator(statisticsTypes.EXPORT_INVOICES, 'res'),
    };
}

export function exportInvoicesErr() {
    return {
        type: actionCreator(statisticsTypes.EXPORT_INVOICES, 'err'),
    };
}
// E X P O R T   I N V O I C E S
